export const IMG = (n) => `/assets/img/${n}`;

export const FLAVOURS = {
  original: {
    id: "original",
    label: "Original Apple",
    name: "Himachal Original Apple Cider",
    short: "Original",
    accent: "#95C11F",
    glow: "rgba(255,255,255,0.75)",
    desc: "Lightly sparkling, crisp and medium sweet, crafted from whole Himachali orchard apples with the natural sweetness of orchard-fresh fruit.",
    notes: ["Crisp orchard apple", "Lightly sparkling", "Medium sweet", "Clean, dry-ish finish"],
    photo: "cans-original-soon.jpg",
  },
  berry: {
    id: "berry",
    label: "Mixed Berry",
    name: "Himachal Mixed Berry Apple Cider",
    short: "Mixed Berry",
    accent: "#B8325A",
    glow: "rgba(139,30,63,0.16)",
    desc: "Juicy and vibrant: Himachali apples meet a Himalayan berry blend for a tart-sweet complexity that loves heat on the plate.",
    notes: ["Himalayan berry blend", "Tart-sweet", "Juicy & vibrant", "Ruby-bright finish"],
    photo: "cans-berry-soon.jpg",
  },
};

export const HOTSPOTS = [
  { id: "flavour", angle: -0.55, y: 0.55, title: "Flavour notes", body: { original: "Crisp orchard apple, light sparkle, medium sweet.", berry: "Tart-sweet Himalayan berries over crisp apple." } },
  { id: "craft", angle: 0.5, y: -0.45, title: "Honest craft", body: { original: "Real apples, no added sugar. <5% ABV.", berry: "Real apples & berries, no added sugar. <5% ABV." } },
  { id: "pair", angle: 0.05, y: -1.1, title: "Pair it with", body: { original: "Spicy curries, tandoori, street food, fish & chips.", berry: "Spicy curries, tandoori, street food, fish & chips." } },
  { id: "serve", angle: 3.6, y: 0.2, title: "Serve", body: { original: "Best served chilled. Do not consume if cloudy.", berry: "Best served chilled. Do not consume if cloudy." } },
];

export const PAIRINGS = [
  { id: "curry", title: "Spicy curries", note: "Cuts through heat & richness" },
  { id: "tandoor", title: "Tandoori", note: "Smoke meets orchard sparkle" },
  { id: "street", title: "Street food", note: "Chaat, pani puri, vada pav" },
  { id: "fish", title: "Fish & chips", note: "The British classic, with a JAI हो!" },
];

export const ERAS = [
  {
    id: "2012",
    years: "2012",
    place: "Yorkshire, UK",
    title: "The spark in a Yorkshire bar",
    text: "One evening over hearty curry, Clive Fernandes and his British colleagues asked: why was there no Indian cider to pair with the rich, flavourful curries so beloved across the UK?",
    cities: ["Yorkshire"],
    photo: "founder-tent2.jpg",
    focus: "uk",
  },
  {
    id: "2013",
    years: "2013–2014",
    place: "Himachal → UK",
    title: "Himachali apples, bottled at source",
    text: "Apples sourced directly from Himachal Pradesh orchards, bottled in Himachal, and exported 100% to the UK. The world's first authentic Indian craft cider is born.",
    cities: ["Himachal", "Bottled in Himachal", "Exported 100% to the UK"],
    photo: "pallets.jpg",
    focus: "route",
  },
  {
    id: "2015",
    years: "2015–2018",
    place: "Across the UK",
    title: "Britain's favourite Indian craft cider",
    text: "Rapid expansion with a strong distributor network across the UK and Europe, and the Best Cider Award at the Great Lakes Cider Competition, USA.",
    cities: ["London", "Leeds", "Manchester", "Edinburgh", "Yorkshire", "Dublin", "Cardiff"],
    photo: "crowd.jpg",
    focus: "ukcities",
    award: true,
  },
  {
    id: "2024",
    years: "2024–Present",
    place: "Homecoming, India",
    title: "The homecoming launch",
    text: "Sold out on Day 2 of 3 at Oktoberfest, Jio World Drive (Mumbai). No. 2 seller at Oktoberfest Kopa Mall (Pune). No. 1 seller at Brewchella (Nashik).",
    cities: ["Mumbai", "Pune", "Nashik"],
    photo: "soldout.jpg",
    focus: "india",
  },
];

export const METRICS = [
  { value: 40000, suffix: "+", label: "Bottles sold", sub: "plus thousands of cans across the UK, Europe & USA" },
  { value: 100, suffix: "+", label: "Premier restaurants & bars", sub: "across the United Kingdom" },
  { value: 8, suffix: "+", label: "Countries", sub: "England, Ireland, Scotland, USA, France, Italy, Spain, India" },
  { value: 100, suffix: "%", label: "Repeat glass purchase", sub: "at flagship events: every first glass led to a second" },
];

export const TESTIMONIALS = [
  { quote: "This week, fresh from the Himalayan foothills, a rare Indian cider. Exclusive to The Stable restaurants.", name: "The Cider Box", handle: "@theciderbox", date: "Jan 2018" },
  { quote: "The loveliest, lightest refreshing cider to go with the tastiest curry at Tharavadu, Leeds.", name: "Claire Bear", handle: "Tharavadu Leeds", date: "Aug 2018" },
  { quote: "Brewed in the foothills of the Himalayas, made using pure mountain water and Himachali apples.", name: "Jane Cuthbertson", handle: "Barrica Wines", date: "Oct 2017" },
  { quote: "Beautiful with a bhuna and fabulous with fish and chips!", name: "mmm", handle: "@mmm_newcastle", date: "Jun 2017" },
  { quote: "We got to relax and enjoy last night… have to say it's the best cider we have tasted!", name: "Premier Hop", handle: "@premierhop", date: "Jan 2017" },
  { quote: "Leeds curry lovers. You gotta try this fantastic cider. Perfection with spice.", name: "Popagooda", handle: "@popagooda", date: "Jul 2017" },
  { quote: "UK friends brought it for New Year's, supplies gone. You must stock this, it's amazing. Please supply Ireland!", name: "Andi", handle: "@grumpycorkchef", date: "Jan 2017" },
  { quote: "Enjoying Saturday sun & fun at Foodies Festival. Picks: Rollright cheese & Himachal Cider.", name: "2 x Foodies", handle: "Foodies Festival, Oxford", date: "Sep 2017" },
  { quote: "Bought some last week and I will be buying more. A really refreshing taste from India.", name: "Matthew Williams", handle: "@funkynoise74", date: "Mar 2017" },
];

export const PARTNERS_GLOBAL = ["The Cider Box", "Tharavadu Leeds", "Barrica Wines", "Foodies Festival", "Piccolino", "Akbar's", "Café Spice Namaste", "Kiplings", "Oh! Calcutta", "The Stable"];
export const PARTNERS_INDIA = ["Jio World Drive", "Royal Western India Turf Club", "Poona Brewout", "BrewChella", "The Amazing Pint", "The Poona Cartel", "Revolve", "Gin & Hops"];

export const SNAPSHOTS = [
  { img: "snap-london.jpg", city: "London" },
  { img: "snap-manchester.jpg", city: "Manchester" },
  { img: "snap-leeds.jpg", city: "Leeds" },
  { img: "snap-edinburgh.jpg", city: "Edinburgh" },
  { img: "snap-dublin.jpg", city: "Dublin" },
  { img: "snap-nashik.jpg", city: "Nashik" },
  { img: "snap-pune.jpg", city: "Pune" },
  { img: "snap-mumbai.jpg", city: "Mumbai" },
];

export const CONTACT = {
  company: "Clida Bev Pvt. Ltd.",
  emails: ["info@himachalcider.com", "clive@himachalcider.com"],
  phones: ["+91 81696 67795", "+91 98202 11906"],
  web: "www.himachalcider.com",
  instagram: "https://instagram.com/himachalho",
  twitter: "https://x.com/himachalcider",
};

export const FIND_US = [
  { city: "Mumbai", venues: [["The Berliner", "Versova"], ["Nebo", "Andheri E"], ["Yuhi", "Powai"], ["Piccolino", "Turbe"]] },
  { city: "Pune", venues: [["The Urban Foundry", "Balewadi"], ["Tales & Spirits", "Balewadi"], ["Tales & Spirits", "SB Road"], ["Ba Da Bom", "The Mills"], ["Windmill", "Bavdhan"], ["BNTR", "Koregaon Park"]] },
  { city: "Nashik", venues: [["Tales & Spirits", ""]] },
];
